// import History from './History';

export default {
  priority: 1,
  path: 'history',
  permissions: ['StackHistoryMenu'],
  // component: History,
  component: load(() => import(/* webpackChunkName: "Stack-History" */ './History')),
  name: app.translate('routes.home.attendance.stack.History'),
  icon: 'history',
  drawer: true,
};


